import React, { Fragment } from "react";

import {
  Button,
  Divider,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Grid,
  makeStyles,
  Typography,
  CardHeader,
  Menu,
  MenuItem,
  Fab,
  Hidden,
  Tooltip,
} from "@material-ui/core";
import { MoreVert } from "@material-ui/icons";
import { Add } from "@material-ui/icons";

import Skeleton from "@material-ui/lab/Skeleton";
import moment from "moment";
import BaseLayout from "../../components/BaseLayout/BaseLayout";
import { submitFormPromoMall } from "./Container/FormPromoMall";
import promotionStore from "../../Store/PromotionStore";
import InputSearch from "../../components/InputSearch/InputSearch";
import { AntTab, AntTabs } from "../../components/TabPanel/TabPanel";

import { confirm } from "../../components/ConfirmationDialog/ConfirmationDialog";
import parse from "html-react-parser";
import { useState } from "react";
import { useEffect } from "react";
import propertyStore from "../../Store/PropertyStore";

import PropertyService from "../../Services/PropertyService/index";
import Search from "@material-ui/icons/Search";
import { withWidth } from "@material-ui/core";
import { css, cx } from "emotion";

const styles = (theme) => ({
  header: {
    textAlign: "left",
  },
  textField: {
    color: "#FFFFFF",
    width: "100%",
  },
  section: {
    color: "#8a8888",
    width: "100%",
    background: "#c1c1c1",
    padding: "5px",
  },
  dateMall: {
    margin: "23px 0",
  },
});

const useStyles = makeStyles((theme) => ({
  icon: {
    marginRight: theme.spacing(2),
  },
  heroContent: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(8, 0, 6),
  },
  heroButtons: {
    marginTop: theme.spacing(4),
  },
  cardGrid: {
    paddingTop: theme.spacing(8),
    paddingBottom: theme.spacing(8),
  },
  card: {
    // height: '100%',
    display: "flex",
    flexDirection: "column",
    width: "270px",
    margin: "10px",
  },
  cardMedia: {
    paddingTop: "56.25%", // 16:9
  },
  cardContent: {
    flexGrow: 1,
  },
  footer: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(6),
  },
  paper: {
    padding: theme.spacing(0.5),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  description: {
    fontSize: "12px",
    color: theme.palette.text.secondary,
  },
  colorStart: {
    color: "#4CAF50",
  },
  colorEnd: {
    color: "#F44336",
  },

  // appBar

  demo1: {
    backgroundColor: theme.palette.background.paper,
    marginBottom: 10,
  },
  fab: {
    position: "fixed",
    bottom: theme.spacing(2),
    right: theme.spacing(2),
  },
}));

function ListPromoMall(props) {
  const classes = useStyles();
  const { dataMall, dataTab, dataList } = props;
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const user = JSON.parse(localStorage.getItem("user"));

  const [promotionState, promotionActions] = promotionStore();
  const handleClick = (event) => {
    // console.log("ihzzza");
    if (
      user?.role?.modules[5]?.features[2]?.delete === true ||
      user?.role?.modules[5]?.features[2]?.update === true ||
      user?.role?.modules[1]?.features[0]?.delete === true ||
      user?.role?.modules[1]?.features[0]?.update === true
    ) {
      // console.log("masuk");

      setAnchorEl(event.currentTarget);
    }
  };

  const setStatusRemove = () => {
    confirm(
      `${!dataTab.deleted ? "Remove Item" : "Restore Item"}`,
      `Are you sure to ${!dataTab.deleted ? "remove" : "restore"} this item ?`
    ).then(async (onProcess) => {
      if (!dataTab.deleted) {
        await promotionActions.deletedMall(dataMall.id);
      } else {
        const params = [
          {
            op: "replace",
            path: "/deleted ",
            value: false,
          },
        ];
        let notif = `Successfully Restore Promotion`;
        await promotionActions.patchMall(dataMall.id, params, notif);
      }
      dataList(true);
    });
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Card className={classes.card}>
      <CardMedia
        className={classes.cardMedia}
        image={dataMall.image_banner_url}
        title="Image title"
      />
      <CardContent className={classes.cardContent}>
        <Grid container spacing={2}>
          <Grid item xs={10}>
            <Typography gutterBottom variant="h5" component="h2">
              {dataMall.title}
            </Typography>
          </Grid>
          <Grid item xs={2}>
            <CardHeader
              action={
                <Fragment>
                  <MoreVert onClick={handleClick} />

                  <Menu
                    id="long-menu"
                    elevation={0}
                    anchorEl={anchorEl}
                    getContentAnchorEl={null}
                    keepMounted
                    open={open}
                    onClose={handleClose}
                  >
                    {/* {permissionEditCategoryProduct && */}
                    <MenuItem
                      onClick={() => {
                        // console.log("lon");
                        props.doEdit(dataMall);
                      }}
                    >
                      Highlight
                    </MenuItem>
                    {/* <MenuItem>POPOl</MenuItem> */}

                    {/* {!dataTab.deleted && (
                      <Button onClick={setStatusRemove} color="primary">
                        Remove
                      </Button>
                    )}
                    {dataTab.deleted && (
                      <Button onClick={setStatusRemove} color="primary">
                        Restore
                      </Button>
                    )} */}
                  </Menu>
                </Fragment>
              }
            ></CardHeader>
          </Grid>
        </Grid>
        <Typography className={classes.description}>
          {parse(dataMall.description || "")}
        </Typography>
      </CardContent>
      <Divider />
      <CardActions>
        <Grid container spacing={2} className={classes.paper}>
          <Grid item xs={6}>
            <div>
              <Button size="small" className={classes.colorStart}>
                START
              </Button>
            </div>
            <Typography variant="caption" display="block" gutterBottom>
              {moment(dataMall.start_time).format("DD/MM/YYYY") || "-"}
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <div>
              <Button size="small" className={classes.colorEnd}>
                END
              </Button>
            </div>
            <Typography variant="caption" display="block" gutterBottom>
              {moment(dataMall.end_time).format("DD/MM/YYYY") || "-"}
            </Typography>
          </Grid>
        </Grid>
      </CardActions>
    </Card>
  );
}

function PromoMall(props) {
  const classes = useStyles();
  const [componentWillmount, setComponentWillMount] = React.useState(false);
  const [search, setSearch] = React.useState("");
  const [promotionState, promotionActions] = promotionStore();
  const [expanded, setExpanded] = React.useState(false);

  // anttabs
  const [tab] = React.useState(0);
  const [tabActive, setTabActive] = React.useState(0);
  const prevTabActive = usePreviousTab(tabActive);

  let arrPromotionList = [
    { label: "Mall", deleted: false },
    { label: "Tenant", deleted: true },
    { label: "Highlight" },
  ];

  let perPage = 3;
  const handleTabChange = (event, newTab) => {
    setExpanded(false);
    setTabActive(newTab);
  };

  function usePreviousTab(value) {
    const ref = React.useRef();
    React.useEffect(() => {
      ref.current = value;
    });
    return ref.current;
  }
  const user = JSON.parse(localStorage.getItem("user"));

  const handleGetPromotionMallList = async (refresh, filter) => {
    let newDataProperty = "";
    const res = await PropertyService.getList({
      num: 10,
      operational_level: user?.operational?.level,
      level: user?.operational?.level < 3 ? user?.operational?.level - 1 : "",
      cursor: "",
      parent_id: user?.operational?.level < 3 ? user?.operational?.id : "",
      type: "",
    });
    // console.log(res.data.id);
    // console.log("^^^^^");

    res.data.map((e) => {
      newDataProperty += e.id + ",";
    });

    if (
      arrPromotionList[tabActive].label === "Mall" ||
      arrPromotionList[tabActive].label === "Tenant"
    ) {
      let data_property_id = newDataProperty.slice(
        0,
        newDataProperty.length - 1
      );
      if (filter) {
        data_property_id = filter;
      }
      // console.log(data_property_id);
      var query = {
        num: perPage.toString(),
        cursor:
          refresh === false && tabActive === prevTabActive
            ? promotionState.header["x-cursor"]
            : "",
        position: "",
        deleted: "false",
        keyword: search,
        current_date: moment().format("YYYY-MM-DD"),
        is_active: 1,
        type:
          arrPromotionList[tabActive].label === "Mall" ? "property" : "tenant",
        property_id: data_property_id || "",
      };
    } else {
      var query = {
        num: perPage.toString(),
        cursor:
          refresh === false && tabActive === prevTabActive
            ? promotionState.header["x-cursor"]
            : "",
        position: "",
        deleted: "false",
        keyword: search,
        is_landing: "1",
        current_date: moment().format("YYYY-MM-DD"),
        // type:
        //   arrPromotionList[tabActive].label === "Mall" ? "property" : "tenant",
        property_id: newDataProperty.slice(0, newDataProperty.length - 1) || "",
      };
    }
    promotionActions.getMall(
      query,
      refresh
      // refresh === false && tabActive === prevTabActive ? true : false
    );
  };

  const handleActions = (value) => {
    if (value) {
      submitFormPromoMall("Update Promotion Mall", value).then(
        (onProcess) => {},
        (onCancel) => {
          // setComponentWillMount(!componentWillmount);
          handleGetPromotionMallList(true);
        }
      );
    } else {
      submitFormPromoMall("Create Promotion Mall", null).then(
        (onProcess) => {},
        (onCancel) => {
          // setComponentWillMount(!componentWillmount);
          handleGetPromotionMallList(true);
        }
      );
    }
  };

  React.useEffect(() => {
    // Add delay in search
    const timeout = setTimeout(() => {
      handleGetPromotionMallList(true);
    }, 500);

    return () => clearTimeout(timeout);
  }, [componentWillmount, promotionActions, search, tabActive]);

  const handleSearch = (e) => {
    setSearch(e.target.value);
  };
  //START SELECT PROPERTY
  const [propertyState, propertyActions] = propertyStore();
  // let perPage = 10;
  const [selectProperty, setselectProperty] = useState({
    id: "",
    name: "Choose Mall",
  });
  const [openoptionProperty, setopenoptionProperty] = useState(false);
  const [insearchProperty, setinsearchProperty] = useState("");

  const loadoptionProperty = (e) => {
    const refresh = true;
    const propertyType = "";
    setinsearchProperty(e.target.value);
    var query = {
      num: perPage.toString(),
      operational_level: user?.operational?.level,
      level: user?.operational?.level < 3 ? user?.operational?.level - 1 : "",
      type: propertyType || "",
      parent_id: user?.operational?.level < 3 ? user?.operational?.id : "",
      cursor: refresh ? "" : propertyState.header["x-cursor"] || "",
      keyword: e.target.value,
    };
    propertyActions.getList(query, refresh);
  };
  const loadoptionProperty2 = (e) => {
    const refresh = true;
    const propertyType = "";
    var query = {
      num: perPage.toString(),
      operational_level: user?.operational?.level,
      level: user?.operational?.level < 3 ? user?.operational?.level - 1 : "",
      type: propertyType || "",
      parent_id: user?.operational?.level < 3 ? user?.operational?.id : "",
      cursor: refresh ? "" : propertyState.header["x-cursor"] || "",
    };
    propertyActions.getList(query, refresh);
  };

  useEffect(() => {
    loadoptionProperty2();
  }, []);
  // console.log(selectProperty);
  // END SELECT PROPERTY

  return (
    <BaseLayout>
      <Fragment>
        {/* list promotion mall */}
        <Grid container style={{ padding: 5, marginBottom: 10 }}>
          <Grid
            container
            item
            xs={10}
            direction="row"
            alignItems="flex-end"
            justify="flex-start"
          >
            <h1>Promo Highlight</h1>
          </Grid>
        </Grid>
        {/* list promotion mall end */}

        <Grid container style={{ padding: 5, marginBottom: 10 }}>
          <Grid
            container
            item
            xs={10}
            direction="row"
            alignItems="flex-end"
            justify="flex-start"
          >
            <InputSearch
              value={search}
              onChange={(e) => {
                handleSearch(e);
              }}
              placeholder="Search by Title"
            />
          </Grid>

          <Grid
            container
            item
            xs={10}
            direction="row"
            alignItems="flex-end"
            justify="flex-start"
          >
            {/* DROPDOWN PROPERTY */}
            <div class="dropdown mt-2 w-100">
              <div
                className={
                  props.width === "xs" || props.width === "sm"
                    ? cx(
                        css`
                          width: 100% !important;
                        `,
                        "input-icons"
                      )
                    : "input-icons"
                }
              >
                <Search className="icon" />
                <input
                  // type="text"
                  // {...props}
                  name="search"
                  className="input-search"
                  // id="search"
                  placeholder="Sort by property"
                  // name="search"
                  id="dropdownMenuButton"
                  data-toggle="dropdown"
                  value={insearchProperty}
                  type="text"
                  onChange={loadoptionProperty}
                  autoComplete="off"
                />
                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                  <div
                    onClick={() => {
                      setselectProperty({
                        id: "",
                        name: "all",
                      });
                      setinsearchProperty("All");
                      handleGetPromotionMallList(true, "");
                      // handleFilterproperty(e.id);
                    }}
                    // onClick={() => {
                    //   handleGetTenantList(e.id);
                    //   getBrand(e.id);
                    //   setinsearchBrand("");
                    //   setinsearch("");
                    // }}
                    class="dropdown-item"
                  >
                    All
                  </div>

                  {propertyState.data.map((e) => {
                    // console.log(e);
                    return (
                      <>
                        <div
                          onClick={() => {
                            setselectProperty({
                              id: e.id,
                              name: e.name,
                            });
                            setinsearchProperty(e.name);
                            handleGetPromotionMallList(true, e.id);
                            // handleFilterproperty(e.id);
                          }}
                          // onClick={() => {
                          //   handleGetTenantList(e.id);
                          //   getBrand(e.id);
                          //   setinsearchBrand("");
                          //   setinsearch("");
                          // }}
                          class="dropdown-item"
                        >
                          {e.name}
                        </div>
                      </>
                    );
                  })}
                </div>
              </div>

              {/* <input
                // id="search"
                placeholder="sort by property"
                name="search"
                id="dropdownMenuButton"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                // className={{ backgroundColor: "coral" }}
                className="form-control bg-secondary"
                // margin="normal"
                variant="outlined"
                value={insearchProperty}
                type="text"
                inputProps={{ maxLength: 61 }}
                // validators={["required", "maxStringLength:60"]}
                // errorMessages={[
                //   "Title is required",
                //   "maximum character is 60",
                // ]}
                onChange={loadoptionProperty}
                autoComplete="off"
                // autoFocus
              /> */}

              {/* </> */}
              {/* ) : null} */}
            </div>
            {/* END DROPDOWN PROPERTY */}
          </Grid>
          <Grid container item xs={2} justify="flex-end" alignItems="flex-end">
            <Hidden xsDown implementation="css">
              {props.params.create && (
                <Tooltip
                  title="add users"
                  aria-label="add"
                  arrow
                  placement="bottom"
                >
                  <Fab
                    onClick={() => handleActions(null)}
                    color="secondary"
                    variant="extended"
                    aria-label="add"
                    style={{
                      marginRight: "10px",
                      borderRadius: 0,
                      padding: "0 30px",
                    }}
                  >
                    <Add /> Add{" "}
                  </Fab>
                </Tooltip>
              )}
            </Hidden>
          </Grid>
        </Grid>

        <Grid item xs={12}>
          <div className={classes.demo1}>
            <Grid container>
              <Grid
                container
                item
                xs
                direction="row"
                alignItems="flex-end"
                justify="flex-start"
              >
                <AntTabs
                  style={{ marginTop: "10px" }}
                  value={tabActive !== "" ? tabActive : 0}
                  onChange={handleTabChange}
                  variant="scrollable"
                  scrollButtons="auto"
                >
                  {arrPromotionList.map((promotionList, keyPromotionList) => {
                    return (
                      <AntTab
                        key={keyPromotionList}
                        label={promotionList.label}
                      />
                    );
                  })}
                </AntTabs>
              </Grid>
            </Grid>
          </div>

          <Grid item xs={12} container justify="center">
            {(promotionState.isLoading
              ? Array.from(new Array(10))
              : promotionState.data
            ).map((value, key) => {
              return (
                <Fragment key={key}>
                  {value ? (
                    <ListPromoMall
                      key={key}
                      dataMall={value}
                      dataTab={arrPromotionList[tabActive]}
                      dataList={handleGetPromotionMallList}
                      // permissionEditCategoryProduct={props.params.update}
                      // doEdit={() => {
                      //     handleActions(value);
                      // }}

                      doEdit={() => {
                        // console.log("lodnsad");
                        handleActions(value);
                      }}

                      // permissionDeleteCategoryProduct={props.params.delete}
                      // doDelete={() => {
                      //     handleDelete(value);
                      // }}
                    />
                  ) : (
                    <Card className={classes.card}>
                      <CardHeader
                        avatar={
                          <Skeleton
                            variant="circle"
                            width="40px"
                            height="40px"
                          />
                        }
                        title={<Skeleton width="20%" height="10px" />}
                        subheader={<Skeleton width="5%" height="10px" />}
                      />
                    </Card>
                  )}
                </Fragment>
              );
            })}
          </Grid>

          {!promotionState.isLoading && promotionState.data.length === 0 && (
            <Grid item xs={12}>
              <div className={classes.demo1}>
                <Grid
                  item
                  xs
                  container
                  justify="center"
                  style={{ margin: 10, padding: 12 }}
                >
                  <span>No Data</span>
                </Grid>
              </div>
            </Grid>
          )}

          {promotionState.data.length >= perPage - 1 && (
            <Grid
              container
              direction="row"
              justify="center"
              alignItems="center"
              style={{ padding: "10px" }}
            >
              {promotionState.lastPage ? (
                <h2>~</h2>
              ) : (
                <Button
                  onClick={() => handleGetPromotionMallList(false)}
                  size="small"
                  color="secondary"
                  variant="contained"
                  disabled={promotionState.isLoading}
                >
                  {promotionState.isLoading ? "Please Wait" : "Load More"}
                </Button>
              )}
            </Grid>
          )}
          <Hidden smUp implementation="css">
            {props.params.create && (
              <Tooltip
                title="add reservation"
                aria-label="add"
                arrow
                placement="left"
              >
                <Fab
                  aria-label="Add"
                  classes={{ root: "FabMobile" }}
                  className={classes.fab}
                  color="primary"
                  onClick={() => handleActions(null)}
                >
                  <Add />
                </Fab>
              </Tooltip>
            )}
          </Hidden>
        </Grid>
      </Fragment>
    </BaseLayout>
  );
}

export default PromoMall;
